import { useContext, useEffect, useState } from "react";
import {
    Grid,
    Avatar,
    Typography,
    Link,
    CardMedia,
    CardContent,
    Card,
    Paper,
} from "@material-ui/core";
import { ApptContext, FacilityByDate, SchedulesByDate } from "../../../../../../store";
import useStyles from "../../../../../../css/styles_PE";
import { formatphone, GetAdminSettingValue } from "../../../../../../api/PE_API";//FB 8024
import SlotsContainer_Date from "../Components/SlotsContainer_Date";

// Update log
// FB  6192   02/06/2023  DK  To display the available schedules of the Date
// FB  7413   09/25/2023  GA  Orady - Update the map link to the correct one
// FB  8024   01/03/2023  SK  Including Recent Patient Engagement Enhancements to Patient Portal
// FB  8214   02/01/2024  SK  Accept Case Sensitive Admin Setting Value for Enable PE Custom Appointments in API and Portal and PE

interface IDateScheduleRowProps {
    Schedules: SchedulesByDate[];
    FacilityByDate: FacilityByDate;
    Limited: number;
    indexNumber: number;
    Index: number;
    isLoading: any;
}


export default function SlotsByDate(props: IDateScheduleRowProps) {
    const styles = useStyles();
    const { state, dispatch } = useContext(ApptContext);
    const [disableEvents, setDiableEvents] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const SchedulingPhone = formatphone(props.FacilityByDate.SchedulinPhone);

    useEffect(() => {
        props.isLoading(isLoading);
    }, [isLoading])
    //FB 8024 - Begin
    const [customAppointment, setCustomAppointment] = useState("");
    async function fetchCustomAppointmentDetails() {
        const customApptAdmin = (await GetAdminSettingValue("Enable PE Custom Appointments"))[0].toLowerCase();//FB 8214
        if (customApptAdmin == "true") {
            let data = sessionStorage.getItem("AppointmentType");
            if (data != null) {
                setCustomAppointment(data);
            }
        }
    }

    useEffect(() => {
        fetchCustomAppointmentDetails();
    }, []);
    //FB 8024 - End

    return props.FacilityByDate !== undefined ? (
        <div>
            {window.innerWidth <= 768 ? (
                <div>
                    <Grid
                        container
                        spacing={3}
                        direction="row"
                        alignContent="center"
                        justify="center"
                    >
                        <Grid item xs={12}>
                            {state.AppointmentType === "telederm" ? (
                                <Card
                                    className={styles.slotspage_Card}
                                    style={{ boxShadow: "none" }}
                                >
                                    <CardMedia style={{ marginTop: 15 }}>
                                        <Avatar
                                            className={styles.slotslocation_Avatar}
                                            src={
                                                "/Images/Locations/" +
                                                props.FacilityByDate.Facility_n +
                                                ".jpg"
                                            }
                                        />
                                    </CardMedia>
                                    <CardContent>
                                        <Typography variant="h6">
                                            <b>{props.FacilityByDate.Facility_Name}</b>
                                        </Typography>
                                        <Typography>
                                            {SchedulingPhone}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            ) : (
                                <Card
                                    className={styles.slotspage_Card}
                                    style={{ boxShadow: "none" }}
                                >
                                    <CardMedia style={{ marginTop: 15 }}>
                                        <Avatar
                                            className={styles.slotslocation_Avatar}
                                            src={
                                                "/Images/Locations/" +
                                                props.FacilityByDate.Facility_n +
                                                ".jpg"
                                            }
                                        />
                                    </CardMedia>
                                    <CardContent>
                                        <Typography variant="h6">
                                            <b>{props.FacilityByDate.Facility_Name}</b>
                                        </Typography>
                                        <Typography
                                            style={{
                                                fontSize: "medium",
                                                display:
                                                    props.FacilityByDate.Facility_Address === "" ||
                                                        props.FacilityByDate.Facility_Address === null
                                                        ? "none"
                                                        : "block",
                                            }}
                                        >
                                            {props.FacilityByDate.Facility_Address}
                                        </Typography>
                                        <Typography
                                            style={{
                                                fontSize: "medium",
                                                display:
                                                    props.FacilityByDate.Facility_Address === "" ||
                                                        props.FacilityByDate.Facility_Address === null
                                                        ? "none"
                                                        : "block",
                                            }}
                                        >
                                            {props.FacilityByDate.Facility_City},{" "}
                                            {props.FacilityByDate.Facility_State},{" "}
                                            {props.FacilityByDate.Facility_Zip}
                                        </Typography>
                                        <Typography>
                                            {SchedulingPhone}
                                        </Typography>
                                        <Typography
                                            style={{
                                                display:
                                                    props.FacilityByDate.Facility_Address === "" ||
                                                        props.FacilityByDate.Facility_Address === null
                                                        ? "none" : "block",
                                            }}
                                        >
                                            <Link
                                                href={
                                                    props.FacilityByDate.GOOGLE_MAPS_LINK
                                                }//FB 7413
                                                target="_blank"
                                            >
                                                View Map
                                            </Link>
                                        </Typography>
                                        {/* FB 8024 - Begin */}
                                        <Typography>
                                            {customAppointment && (
                                                <>
                                                    {customAppointment}
                                                </>
                                            )}
                                        </Typography>
                                        {/* FB 8024 - End */}
                                    </CardContent>
                                </Card>
                            )}
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        spacing={3}
                        direction="row"
                        alignContent="center"
                        justify="center"
                        style={{
                            display: "flex",
                            pointerEvents: disableEvents ? "none" : "auto",
                        }}
                    >
                        <Grid item xs={10} style={{ overflowX: "auto" }}>
                            {props.FacilityByDate.Slots.length > 0 ? (
                                <SlotsContainer_Date
                                    limited={1}
                                    schedulesTest={props.FacilityByDate}
                                    employeeName={
                                        props.Schedules[props.indexNumber]
                                            .Employee_First_Name +
                                        " " +
                                        props.Schedules[props.indexNumber]
                                            .Employee_Last_Name
                                    }
                                    employeeid={
                                        props.Schedules[props.indexNumber].Employee_N
                                    }
                                    facilityid={props.FacilityByDate.Facility_n}
                                    facilityName={props.FacilityByDate.Facility_Name}
                                    facilityAddress={
                                        props.FacilityByDate.Facility_Address +
                                        ", " +
                                        props.FacilityByDate.Facility_City +
                                        ", " +
                                        props.FacilityByDate.Facility_State +
                                        ", " +
                                        props.FacilityByDate.Facility_Zip
                                    }
                                    facilityPhone={SchedulingPhone}
                                    onCallback={setDiableEvents}
                                    isLoading={setIsLoading}
                                    duration={props.Schedules[props.Index].Duration}
                                />
                            ) : (props.Schedules[props.indexNumber].AvailableSlotsCount <= 0 &&
                                props.Schedules[props.indexNumber].NextAvailability === null) ? (
                                <Grid item style={{ margin: "auto" }}>
                                    <Grid
                                        container
                                        direction="column"
                                        justify="center"
                                        alignItems="center"
                                    >
                                        <Paper
                                            style={{
                                                backgroundColor: "#EDEEEE",
                                                borderRadius: "15px",
                                                padding: 10,
                                                textAlign: "center",
                                            }}
                                        >
                                            <Typography variant="subtitle2">
                                                There are no online appointments available for this date. Please call {SchedulingPhone} to book an appointment
                                            </Typography>
                                        </Paper>
                                    </Grid>
                                </Grid>
                            ) : (
                                <Grid item style={{ margin: "auto" }}>
                                    <Grid
                                        container
                                        direction="column"
                                        justify="center"
                                        alignItems="center"
                                    >
                                        <Paper
                                            style={{
                                                backgroundColor: "#EDEEEE",
                                                borderRadius: "15px",
                                                padding: 10,
                                                textAlign: "center",
                                            }}
                                        >
                                            <Typography variant="subtitle2">
                                                The next available online appointment for this provider is  {props.Schedules[props.indexNumber].NextAvailability}
                                                . If you need an appointment sooner, Please call {SchedulingPhone}.
                                            </Typography>
                                        </Paper>
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                </div>
            ) : (
                <div>
                    <Grid
                        container
                        spacing={3}
                        direction="row"
                        alignContent="center"
                        justify="flex-start"
                        style={{
                            borderBottom: "1px solid rgb(0 0 0 / 25%)",
                            marginTop: 10,
                        }}
                    >
                        <Grid item xs={4} sm={4} md={4}>
                            {state.AppointmentType === "telederm" ? (
                                <Card
                                    className={styles.slotslocation_Card}
                                    style={{ boxShadow: "none", alignItems: "center" }}
                                >
                                    <CardMedia style={{ marginTop: 15 }}>
                                        <Avatar
                                            className={styles.slotslocation_Avatar}
                                            src={
                                                "/Images/Locations/" +
                                                props.FacilityByDate.Facility_n +
                                                ".jpg"
                                            }
                                        />
                                    </CardMedia>
                                    <CardContent style={{ display: "contents" }}>
                                        <Typography variant="h6">
                                            <b>{props.FacilityByDate.Facility_Name}</b>
                                        </Typography>

                                        <Typography>
                                            {SchedulingPhone}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            ) : (
                                <Card
                                    className={styles.slotslocation_Card}
                                    style={{ boxShadow: "none", alignItems: "center" }}
                                >
                                    <CardMedia style={{ marginTop: 15 }}>
                                        <Avatar
                                            className={styles.slotslocation_Avatar}
                                            src={
                                                "/Images/Locations/" +
                                                props.FacilityByDate.Facility_n +
                                                ".jpg"
                                            }
                                        />
                                    </CardMedia>
                                    <CardContent style={{ display: "contents" }}>
                                        <Typography variant="h6">
                                            <b>{props.FacilityByDate.Facility_Name}</b>
                                        </Typography>
                                        <Typography
                                            style={{
                                                fontSize: "medium",
                                                display:
                                                    props.FacilityByDate.Facility_Address === "" ||
                                                        props.FacilityByDate.Facility_Address === null
                                                        ? "none"
                                                        : "block",
                                            }}
                                        >
                                            {props.FacilityByDate.Facility_Address}
                                        </Typography>
                                        <Typography
                                            style={{
                                                fontSize: "medium",
                                                display:
                                                    props.FacilityByDate.Facility_Address === "" ||
                                                        props.FacilityByDate.Facility_Address === null
                                                        ? "none"
                                                        : "block",
                                            }}
                                        >
                                            {props.FacilityByDate.Facility_City},{" "}
                                            {props.FacilityByDate.Facility_State},{" "}
                                            {props.FacilityByDate.Facility_Zip}
                                        </Typography>
                                        <Typography>
                                            {SchedulingPhone}
                                        </Typography>
                                        <Typography
                                            style={{
                                                display:
                                                    props.FacilityByDate.Facility_Address === "" ||
                                                        props.FacilityByDate.Facility_Address === null
                                                        ? "none"
                                                        : "block",
                                            }}
                                        >
                                            <Link
                                                href={
                                                    props.FacilityByDate.GOOGLE_MAPS_LINK
                                                }//FB 7413
                                                target="_blank"
                                            >
                                                View Map
                                            </Link>
                                        </Typography>
                                        {/* FB 8024 - Begin */}
                                        <Typography>
                                            {customAppointment && (
                                                <>
                                                    {customAppointment}
                                                </>
                                            )}
                                        </Typography>
                                        {/* FB 8024 - End */}
                                    </CardContent>
                                </Card>
                            )}
                        </Grid>
                        <Grid
                            item
                            xs={6}
                            sm={7}
                            md={7}
                            className={styles.byDateScrollbar}
                            style={{
                                display: "flex",
                                overflowX: "auto",
                                pointerEvents: disableEvents ? "none" : "auto",
                            }}
                            direction="row"
                        >
                            {props.FacilityByDate.Slots.length > 0 ? (
                                <SlotsContainer_Date
                                    limited={1}
                                    schedulesTest={props.FacilityByDate}
                                    employeeName={
                                        props.Schedules[props.indexNumber]
                                            .Employee_First_Name +
                                        " " +
                                        props.Schedules[props.indexNumber]
                                            .Employee_Last_Name
                                    }
                                    employeeid={
                                        props.Schedules[props.indexNumber].Employee_N
                                    }
                                    facilityid={props.FacilityByDate.Facility_n}
                                    facilityName={props.FacilityByDate.Facility_Name}
                                    facilityAddress={
                                        props.FacilityByDate.Facility_Address +
                                        ", " +
                                        props.FacilityByDate.Facility_City +
                                        ", " +
                                        props.FacilityByDate.Facility_State +
                                        ", " +
                                        props.FacilityByDate.Facility_Zip
                                    }
                                    facilityPhone={SchedulingPhone}
                                    onCallback={setDiableEvents}
                                    isLoading={setIsLoading}
                                    duration={props.Schedules[props.Index].Duration}
                                />
                            ) : (
                                props.Schedules[props.indexNumber].AvailableSlotsCount <= 0 &&
                                props.Schedules[props.indexNumber].NextAvailability === null) ? (
                                <Grid item style={{ margin: "auto" }}>
                                    <Grid
                                        container
                                        direction="column"
                                        justify="center"
                                        alignItems="center"
                                    >
                                        <Paper
                                            style={{
                                                backgroundColor: "#EDEEEE",
                                                borderRadius: "15px",
                                                padding: 10,
                                                textAlign: "center",
                                            }}
                                        >
                                            <Typography variant="subtitle2">
                                                There are no online appointments available for this date. Please call {SchedulingPhone} to book an appointment.
                                            </Typography>
                                        </Paper>
                                    </Grid>
                                </Grid>
                            ) : (
                                <Grid item style={{ margin: "auto" }}>
                                    <Grid
                                        container
                                        direction="column"
                                        justify="center"
                                        alignItems="center"
                                    >
                                        <Paper
                                            style={{
                                                backgroundColor: "#EDEEEE",
                                                borderRadius: "15px",
                                                padding: 10,
                                                textAlign: "center",
                                            }}
                                        >
                                            <Typography variant="subtitle2">
                                                The next available online appointment for this provider is  {props.Schedules[props.indexNumber].NextAvailability}
                                                . If you need an appointment sooner, Please call {SchedulingPhone}.
                                            </Typography>
                                        </Paper>
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                </div>
            )}
        </div>
    ) : (
        <></>
    );
}